import {
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Select,
  SimpleGrid,
  Stack,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  useColorModeValue
} from "@chakra-ui/react";
import { ContatoType } from "models/contato_type";
import { useEffect, useState } from "react";
import InputMask from "react-input-mask";
interface IContactData {
  contatoList: ContatoType[];
  nomeContatoRef: any;
  cargoContatoRef: any;
  telefoneContatoRef: any;
  emailContatoRef: any;
  principalContatoRef: any;
  textColor: string;
  deleteContact: (contato: ContatoType) => void;
  adicionarContact: () => void;
  changeItem : (item: ContatoType, index: number) => void;
}

const ContactData = ({
  contatoList,
  textColor,
  deleteContact,
  adicionarContact,
  cargoContatoRef,
  emailContatoRef,
  nomeContatoRef,
  principalContatoRef,
  telefoneContatoRef,
  changeItem
}: IContactData) => {
  const mask = "(99) 99999-9999";
  const [nome, setNome] = useState("");
  const [cargo, setCargo] = useState("");
  const [email, setEmail] = useState("");
  const [telefone, setTelefone] = useState("");
  const [principal, setPrincipal] = useState("false");

  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");

  const changeNome = (nome: string) => {
    setNome(nome);
    nomeContatoRef.current = nome;
  };

  const changeCargo = (cargo: string) => {
    setCargo(cargo);
    cargoContatoRef.current = cargo;
  };

  const changeEmail = (email: string) => {
    setEmail(email);
    emailContatoRef.current = email;
  };

  const changeTelefone = (telefone: string) => {
    setTelefone(telefone);
    telefoneContatoRef.current = telefone;
  };

  const changePrincipal = (principal: string) => {
    setPrincipal(principal);
    principalContatoRef.current = principal;
  };

  const cleanInput = () => {
    changePrincipal("false");
    changeTelefone("");
    changeCargo("");
    changeEmail("");
    changeNome("");
  };

  const submitContato = () => {
    adicionarContact();
    cleanInput();
  };

  const editItem = (data: ContatoType, value: string, index: number) => {
    const val = contatoList[index];
    val.principal = Boolean(value);
    data = val;
    changeItem(data, index);
  }

  useEffect(() => {}, [contatoList]);

  return (
    <AccordionItem>
      <h2>
        <AccordionButton>
          <Box flex="1" textAlign="left" color={"#422AFB"} fontWeight={"bold"}>
            Contatos
          </Box>
          <AccordionIcon color={"#422AFB"} />
        </AccordionButton>
      </h2>
      <AccordionPanel pb={4}>
        <SimpleGrid columns={5} spacing={4}>
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Nome do Contato
            </FormLabel>

            <Input
              ref={nomeContatoRef}
              value={nome}
              isRequired={false}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="Preencha a Nome do Contato"
              onChange={(e) => changeNome(e.target.value)}
              fontWeight="500"
              size="md"
            />
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Cargo do Contato
            </FormLabel>
            <Input
              ref={cargoContatoRef}
              value={cargo}
              isRequired={false}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="Preencha o Cargo do Contato"
              onChange={(e) => changeCargo(e.target.value)}
              fontWeight="500"
              size="md"
            />
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Email do Contato
            </FormLabel>
            <Input
              ref={emailContatoRef}
              value={email}
              isRequired={false}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="Preencha o Email do Contato"
              onChange={(e) => changeEmail(e.target.value)}
              fontWeight="500"
              size="md"
            />
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Telefone do Contato
            </FormLabel>
            <Input
              ref={telefoneContatoRef}
              value={telefone}
              isRequired={false}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="Preencha o Telefone"
              onChange={(e) => changeTelefone(e.target.value)}
              fontWeight="500"
              size="md"
              as={InputMask}
              mask={mask}
            />
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Contato Principal
            </FormLabel>

            <Select
              value={principal}
              ref={principalContatoRef}
              onChange={(e) => changePrincipal(e.target.value)}
            >
              <option value={"false"}>NÃO</option>
              <option value={"true"}>SIM</option>
            </Select>
          </FormControl>
        </SimpleGrid>

        <Stack>
          <Button
            marginY={10}
            variant={"outline"}
            onClick={() => {
              submitContato();
            }}
            alignSelf={"flex-end"}
            colorScheme="brand"
            isLoading={false}
          >
            Adicionar Contato
          </Button>
        </Stack>

        <Box>
          <Table variant="striped" color="gray.500" mb="24px" mt="12px">
            <Thead>
              <Tr>
                <Th pe="10px" borderColor={borderColor} cursor="pointer">
                  <Flex
                    justifyContent="space-between"
                    align="center"
                    fontSize={{ sm: "10px", lg: "12px" }}
                    color="gray.400"
                  >
                    #NOME
                  </Flex>
                </Th>

                <Th pe="10px" borderColor={borderColor} cursor="pointer">
                  <Flex
                    justifyContent="space-between"
                    align="center"
                    fontSize={{ sm: "10px", lg: "12px" }}
                    color="gray.400"
                  >
                    #CARGO
                  </Flex>
                </Th>

                <Th pe="10px" borderColor={borderColor} cursor="pointer">
                  <Flex
                    justifyContent="space-between"
                    align="center"
                    fontSize={{ sm: "10px", lg: "12px" }}
                    color="gray.400"
                  >
                    #EMAIL
                  </Flex>
                </Th>

                <Th pe="10px" borderColor={borderColor} cursor="pointer">
                  <Flex
                    justifyContent="space-between"
                    align="center"
                    fontSize={{ sm: "10px", lg: "12px" }}
                    color="gray.400"
                  >
                    #TELEFONE
                  </Flex>
                </Th>

                <Th pe="10px" borderColor={borderColor} cursor="pointer">
                  <Flex
                    justifyContent="space-between"
                    align="center"
                    fontSize={{ sm: "10px", lg: "12px" }}
                    color="gray.400"
                  >
                    #PRINCIPAL
                  </Flex>
                </Th>

                <Th pe="10px" borderColor={borderColor} cursor="pointer">
                  <Flex
                    justifyContent="space-between"
                    align="center"
                    fontSize={{ sm: "10px", lg: "12px" }}
                    color="gray.400"
                  >
                    #OPÇÕES
                  </Flex>
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              {contatoList?.map((item, index) => {
                return (
                  <Tr key={`${item.id}-${item}-${index}`}>
                    <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                      {item.nome}
                    </Td>
                    <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                      {item.cargo}
                    </Td>

                    <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                      {item.email}
                    </Td>

                    <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                      {item.telefone}
                    </Td>

                    <Td
                      fontSize={{ sm: "14px" }}
                      borderColor="transparent"
                      width={180}
                    >
                      <Select
                        value={item.principal.toString()}
                        onChange={(e) => editItem(item, e.target.value, index)}
                      >
                        <option value={"false"}>NÃO</option>
                        <option value={"true"}>SIM</option>
                      </Select>
                    </Td>

                    <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                      <Button
                        onClick={() => {
                          deleteContact(item);
                        }}
                        colorScheme="red"
                        variant="ghost"
                        ml="1"
                      >
                        Excluir
                      </Button>
                    </Td>
                  </Tr>
                );
              })}
            </Tbody>
          </Table>
        </Box>
      </AccordionPanel>
    </AccordionItem>
  );
};

export default ContactData;
